export default __webpack_public_path__ + "static/media/imp-min-image.67e06e70.svg";